export class InvoiceDetailsStorageSerializer {
    serializeForStorage(data) {
        return JSON.stringify(data);
    }
    deserializeFromStorage(data) {
        try {
            const info = JSON.parse(data);
            this.assertValid(info);
            return info;
        }
        catch (error) {
            return null;
        }
    }
    assertValid(data) {
        if (typeof data !== "object" ||
            data === null ||
            !("isInvoiceNeeded" in data) ||
            !("vatId" in data)) {
            throw new Error("Invalid invoice details data");
        }
    }
}
